<template lang="html">
  <div class="nav-background-wrapper">
    <div v-if="windowWidth > 1000" class="nav-wrapper">
      <div class="logo-wrapper">
        <router-link :to="{ name: 'Home', params: { lang: $i18n.locale } }">
          <img src="@/assets/images/logo.png" alt="logo image">
        </router-link>
      </div>
      <div class="links-wrapper">
        <div :class="{ active: getActive('Home') }" class="single-link">
          <router-link :to="{ name: 'Home', params: { lang: $i18n.locale } }">{{$t('nav.home')}}</router-link>
        </div>
        <div :class="{ active: getActive('About') }" class="single-link">
          <router-link :to="{ name: 'About', params: { lang: $i18n.locale } }">{{$t('nav.about')}}</router-link>
        </div>
        <div :class="{ active: getActive('Rules') }" class="single-link">
          <router-link :to="{ name: 'Rules', params: { lang: $i18n.locale } }">{{$t('nav.rules')}}</router-link>
        </div>
        <!-- <div class="single-link">
          <router-link :to="{ name: 'About', params: { lang: $i18n.locale } }">{{$t('nav.competitions')}}</router-link>
        </div> -->
        <div :class="{ active: getActive('News') }" class="single-link">
          <router-link :to="{ name: 'News', params: { lang: $i18n.locale } }">{{$t('nav.news')}}</router-link>
        </div>
        <div :class="{ active: getActive('Profile') }" v-if="userIsLoged" class="single-link">
          <router-link :to="{ name: 'Profile', params: { lang: $i18n.locale } }">
            {{$t('nav.profile')}}
            <notification-counter v-if="allNotificationsCount" :counter="allNotificationsCount" />
          </router-link>
        </div>
        <div v-if="userIsLoged" class="link-wrapper">
          <router-link v-if="userIsLoged" :to="{ name: 'NewAd', params: { lang: $i18n.locale } }">
            {{$t('profile.purchase.newSale')}}
          </router-link>
        </div>
      </div>
      <div class="right-part">
        <div class="upper">
          <div v-if="userIsLoged" class="single-link">
            <div class="wish-list-wrapper">
              <router-link tag="div" :to="{ name: 'Favorites', params: { lang: $i18n.locale } }">
                <div class="icon-wrapper">
                  <img src="@/assets/icons/wishList.png" alt="favorite icon">
                  <notification-counter v-if="favoritesLength" :counter="favoritesLength" />
                </div>
              </router-link>
              <router-link :to="{ name: 'Favorites', params: { lang: $i18n.locale } }">{{$t('nav.wishList')}}</router-link>
            </div>
          </div>
          <login-dropdown
            v-if="!userIsLoged"
            :userIsLoged="userIsLoged"
            @changeLoged="$emit('changeLoged', $event)"
          />
          <div v-else class="logout-wrapper">
            <router-link tag="span" v-if="userName" class="user-name" :to="{ name: 'Profile', params: { lang: $i18n.locale } }">{{userName}}, </router-link>
            <span @click="logout()" class="logout"> {{$t('nav.logout')}}</span>
          </div>
          <div v-if="!userIsLoged" @click="openRegisterModal()" class="single-link">
            <span>{{$t('nav.register')}}</span>
          </div>
          <locale-picker />
        </div>
        <div class="lower">
          <search-dropdown />
        </div>
      </div>
    </div>
<!------        izmena ------------>
    <div v-else class="small-nav-wrapper">
      <slide :isOpen="slideIsOpen" @openMenu="openSlide" @closeMenu="closeSlide" noOverlay :closeOnNavigation="false">
        <div class="locPic">
           <locale-picker :blackDiv="true"/>
        </div>
         <search-dropdown @search="closeSlide()" :blackDiv="true"/>
        <div class="links-wrapper">
          <div @click="closeSlide()" class="single-link">
            <router-link :to="{ name: 'Home', params: { lang: $i18n.locale } }">{{$t('nav.home')}}</router-link>
          </div>
          <div @click="closeSlide()" class="single-link">
            <router-link :to="{ name: 'About', params: { lang: $i18n.locale } }">{{$t('nav.about')}}</router-link>
          </div>
          <div @click="closeSlide()" class="single-link">
            <router-link :to="{ name: 'Rules', params: { lang: $i18n.locale } }">{{$t('nav.rules')}}</router-link>
          </div>
          <!-- <div class="single-link">
            <router-link :to="{ name: 'About', params: { lang: $i18n.locale } }">{{$t('nav.competitions')}}</router-link>
          </div> -->
          <div @click="closeSlide()" class="single-link">
            <router-link :to="{ name: 'News', params: { lang: $i18n.locale } }">{{$t('nav.news')}}</router-link>
          </div>
          <div @click="closeSlide()" v-if="userIsLoged" class="single-link">
            <router-link :to="{ name: 'Profile', params: { lang: $i18n.locale } }">
              {{$t('nav.profile')}}
              <notification-counter v-if="allNotificationsCount" :counter="allNotificationsCount" />
            </router-link>
          </div>
          <div @click="closeSlide()" v-if="userIsLoged && favoritesLength" class="single-link">
            <router-link tag="div" :to="{ name: 'Favorites', params: { lang: $i18n.locale } }">
              <div class="icon-wrapper">
                <img src="@/assets/icons/wishList.png" alt="favorite icon">
                <notification-counter v-if="favoritesLength" :counter="favoritesLength" />
              </div>
            </router-link>
          </div>

        </div>
        <div class="border">
     <!--   <login-dropdown
            v-if="!userIsLoged"
            :userIsLoged="userIsLoged"
            @changeLoged="$emit('changeLoged', $event)"
          />
          -->
          <div class="single-link" v-if="!userIsLoged" @click='openSignInModal(), closeSlide()' >{{$t('main.login')}} </div>
          <div v-else class="logout-wrapper1">
           <div @click="closeSlide()"><span @click="logout()" class="logout">{{$t('nav.logout')}}</span></div>
            <div @click="closeSlide()"><router-link tag="span" v-if="userName" class="user-name" :to="{ name: 'Profile', params: { lang: $i18n.locale } }">{{userName}} </router-link></div>

          </div>
          <div v-if="!userIsLoged" @click="openRegisterModal(), closeSlide()" class="single-link">
            <a>{{$t('nav.register')}}</a>
          </div>
     </div>
     <!-- <categories :categories="categories" @changeCategory="changeCategory"/> -->
      </slide>
      <div class="logo-wrapper">
        <router-link @click="closeSlide()" :to="{ name: 'Home', params: { lang: $i18n.locale } }">
          <img src="@/assets/images/logo.png" alt="logo image">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'
import LocalePicker from '@/components/header/LocalePicker.vue'
import LoginDropdown from '@/components/header/LoginDropdown.vue'
import SearchDropdown from '@/components/header/SearchDropdown.vue'
// import Categories from '@/components/topSection/categories.vue'
import NotificationCounter from '@/components/notificationCounter.vue'
import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'
import { mapState } from 'vuex'
export default {
  name: 'Navigation',
  props: {
    userIsLoged: {
      type: Boolean,
      required: true
    },
    windowWidth: {
      required: false,
      type: Number
    }
  },
  components: {
    LocalePicker,
    LoginDropdown,
    SearchDropdown,
    Slide,
    // Categories,
    NotificationCounter
  },
  data () {
    return {
      loginDropdown: false,
      categories: [],
      slideIsOpen : false
    }
  },
  mounted () {
    this.$store.commit('changeFavoritesLength')
    this.getCategories()
  },
  methods: {
    openSlide() {
      this.slideIsOpen = true
    } ,
    closeSlide() {
      this.slideIsOpen = false
    },
    logout () {
      eventBus.$emit('logout')
      api.logout().then(res => {
        localStorage.removeItem('sid')
        this.$emit('changeLoged', false)
        this.$store.commit('setUserName', null)
        this.$store.commit('setUserAdmin', false)
        this.$store.commit('closeWSConnection')
        if (this.$route.name !== 'Home') {
          this.$router.push({ name: 'Home', params: { lang: this.$i18n.locale } })
        }
      }).catch(e => {
        console.log(e)
      })
    },
    openRegisterModal () {
      eventBus.$emit('openModal', { component: 'chooseRegistrationModal' })
    },
    openSignInModal () {
      let params = {
        modalData: { 'userIsLoged': this.userIsLoged },
        component: 'signInMod'
      }
      eventBus.$emit('openModal', params)
    },
    changeCategory (category) {
      const query = {
        category: category.cat_id
      }
      this.$router.push({ name: 'Result', params: this.$route.params, query: query })
    },
    getCategories () {
      api.getCategories().then(res => {
        for (var i = 0; i < res.data.data.length; i++) {
          res.data.data[i].open = false
        }
        this.categories = res.data.data
      }).catch(e => {
        console.log(e)
      })
    }
  },
  computed: {
    ...mapState(['userName', 'favoritesLength', 'allNotificationsCount']),
    getActive () {
      return str => {
        let page = this.$route.name
        if (str === page) {
          return true
        }
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-background-wrapper {
  width: 100%;
  background-color: white;
  position: sticky;
  top: 0px;
  z-index: 2;
  height: 90px;
  box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.06);

  .nav-wrapper {
    display: flex;
    flex-direction: row;
    max-width: 1320px;
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    align-items: center;
    background-color: white;
    white-space: nowrap;

    .right-part {
      display: flex;
      flex-direction: column;
      height: calc(100% - 20px);

      .upper {
        display: flex;
        flex-direction: row;
        height: 50%;
        position: relative;

        .single-link, .logout-wrapper {
          display: flex;
          align-items: center;
        }
      }
      .lower {
        height: 50%;
      }
    }
    .logo-wrapper {
      width: 290px;
      min-width: 120px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .links-wrapper {
      display: flex;
      flex-direction: row;
      margin-right: auto;

      .single-link a {
        position: relative;
        margin-right: 25px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.01em;
        text-decoration: none;
        transition-duration: 0.2s;
        color: $text-color;
        white-space: nowrap;
        text-transform: uppercase;
        border-bottom: none;
        padding-bottom: 5px;
        font-family: 'Open Sans';
      }
      .single-link a:hover {
        color: $text-hover-color;
      }
      .single-link.active {
        a {
          border-bottom: 1px solid $main-color;
        }
      }
      .link-wrapper a{
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.01em;
        text-decoration: none;
        text-transform: uppercase;
        color: #8E3E4C;
        text-decoration: none !important;
      }
    }
    .logout {
      cursor: pointer;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      letter-spacing: 0.02em;
      -webkit-transition-duration: 0.2s;
      transition-duration: 0.2s;
      color: $main-color;
      margin-right: 35px;
      text-transform: lowercase;
      margin-left: 5px;
    }
    .single-link span, .single-link a, .user-name {
      margin-right: 30px;
      font-style: normal;
      font-weight: bold;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      text-decoration: none;
      transition-duration: 0.2s;
      color: $text-color;
      cursor: pointer;
    }
    .single-link span:hover, .single-link a:hover, .user-name:hover {
      color: $text-hover-color;
    }
    .user-name {
      margin-right: 0px;
    }
    .wish-list-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;

      .icon-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-right: 8px;

        img {
          margin-bottom: 2px;
        }
      }
    }
  }
  .small-nav-wrapper {
    display: flex;
    height: 100%;
    width: calc(100% - 40px);
    align-items: center;
    justify-content: flex-end;
    margin: 0 auto;
    position: relative;

    .logout {
      cursor: pointer;
      color: #FFFFFF;
      opacity: 0.5;
    }

    .single-link a {
      cursor: pointer;
    }
    .links-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .single-link {
        margin-bottom: 20px;
        position: relative;

        a {
          font-weight: bold;
          font-size: 15px;
          line-height: 21px;
          letter-spacing: 0.02em;
          text-decoration: none;
          color: white;
          white-space: nowrap;
        }
      }
      .single-link:hover {
        transform: scale(1.1);
        // color: $text-hover-color;
      }
    }
    .categories-wrapper {
      background: white;
      height: 300px;
      min-width: auto;
      display: flex;
      flex-direction: column;

      .categories {
        position: relative !important;
      }
    }
  }
}
.logout-wrapper1{
  width: 100%;
  display: flex;
  justify-content: space-between !important;
  font-family: Ubuntu;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 15px;
  /* identical to box height */

  letter-spacing: 0.02em;

  color: #FFFFFF;

}

</style>
<style lang="scss">
.nav-background-wrapper {
  .bm-burger-button {
    left: 20px;
    top: 32px;
    height: 20px;
    width: 25px;
  }
}
.bm-cross-button.cross-style{
  left:1px;
}
.bm-menu{
  top:0px;
  left:0px;
  // position: relative;
  padding-top:30px;
}
.bm-item-list{
  position:relative;
  //height: 50vh;
  padding-top:30px;
}
.locPic{
  position:absolute;
  top:-25px;
  right: 10px;
.picker-wrapper{
  margin-bottom:50px !important;

}}
.bm-menu{
.border{
  width:239px;
  box-sizing:border-box;
  background-color:#3f3f41;
  // position: fixed;
  // bottom: 100px;
  border-top: 1px solid #838383;
  margin-right: 30px;
  margin-top:auto;
  display: flex;
  justify-content: space-between !important;
}
}

</style>
